// usergroup object repository

import http from '../services/http'
import auth from '../services/auth'

const BASE_ROUTE = '/available_usergroups'

export default {
  fetchGroups: function () {
    // fetch the list of available usergroups
    return http.get(`${BASE_ROUTE}/`, auth.getAuthHeader())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/GroupRepository.js